import { useGetLkmAppealStatisticsQuery } from 'feature/lkmAppeals/redux/LkmAppeals.api'
import styles from './LkmAppealsStatistics.module.scss'

import { formatPrice } from 'helpers/formatPrice'

export const LkmAppealsStatistics = () => {
  const { data } = useGetLkmAppealStatisticsQuery()

  if (!data) return <></>

  return (
    <div className={styles.appealsStatistic}>
      <div className={styles.appealsStatistic__statisticValue}>
        <span className={styles.appealsStatistic__statisticNumber}>
          {data.count}
        </span>
        <span className={styles.appealsStatistic__statisticText}>
          Успешно закрытых заявок
        </span>
      </div>
      <div className={styles.appealsStatistic__statisticValue}>
        <span className={styles.appealsStatistic__statisticNumber}>
          {formatPrice(data.sum, false)}
        </span>
        <span className={styles.appealsStatistic__statisticText}>
          общая сумма, ₽
        </span>
      </div>
      <div className={styles.appealsStatistic__statisticValue}>
        <span className={styles.appealsStatistic__statisticNumber}>
          {data.grade}
        </span>
        <span className={styles.appealsStatistic__statisticText}>
          ваш рейтинг
        </span>
      </div>
    </div>
  )
}
